export class VpJob {
    public id!: string
    public name!: string
    pmUserId!: number
    siteSuperUserId!: number
    peUserId!: number
    jcaUserId!: number
    jobType!: string
    jobStatus!: number
    projectMgr!: number
}
